import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
 * VuwArrayChild for VuwArrayField (extends VuwField)
 * @options
 * - {String} requiredText
 * - {Object} dataParams
 */
vuwer.appendKlass("VuwArrayChild", {
	inpType: "set",
	childKlass: "VuwField",
	_disableInpTypes: ["array", "link", "file"],
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwArrayChild").parent._initialize.call(this, opt) ) {
			// dataParamsからVuwFieldを生成
			u_.isObject(this.dataParams) && Object.keys(this.dataParams).forEach(function(pk) {
				var pi = this.dataParams[pk];
				if(this._disableInpTypes.indexOf(pi.inpType) < 0) {
					this.add( pk, Object.assign({
						vuwType: pi.inpType + "Field",
						paramKey: this.paramKey.replace(/_(\d+)$/, "_" + pk + "_$1")
					}, pi) );
				}
			}, this);
			
			this.onReady(function() {
				var form = this.getForm();
				(form && form.config.requiredText) && (this.requiredText = form.config.requiredText);
				return this.renderField();
			});
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		$self.on("click", ".btn-del", function(e) {
			var vuw = $.data(e.delegateTarget, "vuw");
			e.preventDefault();
			if(vuw.container) {
				vuw.container.remove(vuw.name);
				!!vuw.container.$self && vuw.container.$self.removeClass("is-limit");
			}
		});
	},
	
	validate: function validate() {
		var err_cnt = 0;
		this.getChildren().forEach(function(vuw) {
			vuw.validate() || err_cnt++;
		});
		return !err_cnt;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		if( u_.isObject(value) ) {
			this.getChildren().forEach(function(vuw) {
				if( value.hasOwnProperty(vuw.name) ) {
					vuw.setVal(value[vuw.name], antiTriggerChange);
				} else {
					vuw.clearVal();
				}
			});
		} else {
			this.getChildren().forEach(function(vuw) {
				vuw.clearVal();
			});
		}
		return this;
	},
	
	getVal: function getVal() {
		var
			flg = false,
			val = {};
		
		this.getChildren().forEach(function(vuw) {
			if( !vuw.$inp || !vuw.$inp.prop("disabled") ) {
				val[vuw.name] = vuw.getVal();
			}
			if( !flg && (val[vuw.name] || val[vuw.name] === 0) ) {
				flg = true;
			}
		}, this);
		return flg && val;
	},
	
	getCopiedElement: function getCopiedElement() {
		var
			val = this.getVal(),
			flg = false,
			keys, len, i, $clone;
		
		if( u_.isObject(val) ) {
			keys = Object.keys(val);
			len = keys.length;
			
			for(i = 0; i < len; i++) {
				if(val[ keys[i] ] || val[ keys[i] ] === 0) {
					flg = true;
					break;
				}
			}
			
			if(flg) {
				$clone = Klass("VuwArrayChild").parent.getCopiedElement.call(this).attr("id", null);
				!!$clone && $clone.children().wrapAll( $("<div/>").addClass("fields") );
			}
		}
		
		return $clone;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var clones = [];
		this.getChildren().forEach(function(vuw) {
			var $clone = vuw.getCopiedElement();
			if($clone) {
				vuw.$name.clone().attr("for", null).prependTo($clone);
				clones.push($clone);
			}
		});
		return clones;
	},
	
	_renderField: function _renderField() {
		var $elm = $("<div/>").addClass("fields");
		
		this.getChildren().forEach(function(vuw) {
			var $target;
			
			vuw.$self = $("<var/>").appendTo($elm);
			vuw.renderField();
			
			if(vuw.$inp.length) {
				vuw.$inp.attr( "name", vuw.$inp.attr("name").replace(/_(\d+)$/, "[$1]") );
				if(vuw.$inp.length === 1) {
					$target = vuw.$inp;
				}
			}
			
			!$target && ($target = vuw.$self);
			
			vuw.$name = $("<label/>").addClass("param-name").attr( "for", $target.attr("id") ).append(
				$("<span/>").html( $.parseHTML(this.dataParams[vuw.name].name || "") )
			).prependTo(vuw.$self);
			
			if(vuw.required) {
				$("<span/>").addClass("required").text(this.requiredText || "").appendTo(vuw.$name);
			}
			
			vuw.$self.attr("data-name", vuw.name);
		}, this);
		
		return $("<div/>").addClass("vuw-array-child").attr({
			"data-index": (this.name.indexOf("_") >= 0) ? this.name.split("_")[1] : "-1"
		}).append(
			$elm,
			$("<div/>").addClass("child-controller").append(
				$("<a/>").addClass("btn-del").attr({
					href: "./",
					title: "削除"
				}).append("<span/>")
			)
		);
	}
}, "VuwField");
